import React from 'react'
import "./LoginBtn.css";

function SignupBtn() {
  return (
    <div>
        <button className="btn-53">
  <div className="original">Signup</div>
  <div className="letters">
    
    <span>S</span>
    <span>i</span>
    <span>g</span>
    <span>n</span>
    <span>u</span>
    <span>p</span>
  </div>
</button>
    </div>
  )
}

export default SignupBtn
